import React from 'react';
import { EditableQuestion } from '../../../../types';
import QuestionViewer from './components/QuestionViewer';
import QuestionEditor from '../QuestionEditor/QuestionEditor';
import { useEditing } from './hooks/useEditing';

interface Props {
  question: EditableQuestion;
  index: number;
}

const QuestionContent = ({ question, index }: Props) => {
  const { isEditing, startEditing, cancelEditing } = useEditing(question);

  if (isEditing) {
    return <QuestionEditor onCancelEdit={cancelEditing} index={index} question={question} />;
  }

  return <QuestionViewer question={question} onEditClick={startEditing} />;
};

export default QuestionContent;
